import { optum, uhc, dxDark, HarmonyTheme } from '@uhg-harmony/foundations';

export enum ThemeType {
  Optum = 'optum',
  Uhc = 'uhc',
  Dark = 'dark',
  Rally = 'rally',
  CustomTheme1 = 'customtheme1',
  CustomTheme2 = 'customtheme2',
  CustomTheme3 = 'customtheme3',
}

export const harmonyThemeMap = new Map<ThemeType, HarmonyTheme>([
  [ThemeType.Optum, optum],
  [ThemeType.Uhc, uhc],
  [ThemeType.Dark, dxDark],
]);

export const themeOptions: ThemeType[] = [
  ThemeType.Optum,
  ThemeType.Uhc,
  ThemeType.Dark,
  ThemeType.Rally,
  ThemeType.CustomTheme1,
  ThemeType.CustomTheme2,
  ThemeType.CustomTheme3,
];
